module.exports = __webpack_public_path__ + "static/img/6.fb870685.jpg";